module.exports = __webpack_public_path__ + "static/media/Helicopter_Landing_Aids_01.10576ccf.jpg";